<template>
  <div class="w-200">
    <v-autocomplete
      label="Status Produtos"
      v-model="VALOR"
      :items="itens"
      outlined
      dense
      hide-details
      small-chips
      multiple
    >
      <template #prepend-item>
        <SysItemListaSelecionaTudo
          v-model="VALOR"
          :itens="itens"
          valor-chave="value"
        />

        <v-divider />
      </template>

      <template #selection="{ item }">
        <TextoOutrosFiltrosSelecionadosAutocomplete
          :filtros="VALOR"
          :item="item"
          item_key="value"
          item_value="text"
          retornar_texto_completo
        />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete
  from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";

export default {
  components: {TextoOutrosFiltrosSelecionadosAutocomplete, SysItemListaSelecionaTudo},
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: Array,
  },
  data: () => ({
    itens: [
      { text: 'Ativos', value: 'A' },
      { text: 'Fora de Linha', value: 'FL' },
    ],
  }),
  computed: {
    VALOR: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>

<style>

</style>
